import {NavbarLink} from '@data/__generated__/types.main'
import classnames from '@helpers/misc/classnames'
import Link from 'next/link'
import {useRouter} from 'next/router'
import {IoMenu as HamburgerMenu} from 'react-icons/io5'

import SideModal from '@components/V3/SideModal'
import {useUserPreferencesPartial} from '@data/queries/preferences/userPreferences.main'
import {getPath} from '@helpers/router/getPathname'
import {Suspense, useState} from 'react'
import GoToOrderButton from '../GoToOrderButton'
import {ORDER_PAGE, comparePaths} from './comparePaths'

type NavbarLinksProps = {
  links: NavbarLink[]
}

function MobileNavbarLinksInner(props: Readonly<NavbarLinksProps>) {
  const [openSideMenu, setOpenSideMenu] = useState<boolean>(false)
  const {links} = props
  const router = useRouter()
  const currentPath = getPath(router)
  const comparedOrderPage = comparePaths(currentPath, ORDER_PAGE)
  const isLoggedIn = useUserPreferencesPartial().data?.userPreferences?.userId
  const linksAvailable = isLoggedIn ? links : links.filter(link => !link.showLoggedIn)

  const onClickSideBarLink = (e, comparedPaths) => {
    if (comparedPaths.samePath && comparedPaths.sameSearch) {
      e.preventDefault()
    }
    setOpenSideMenu(false)
  }

  const renderLinks = (link, index) => {
    if (ORDER_PAGE === link.path) {
      return null
    }

    if (!link.path.startsWith('/')) {
      return (
        <a
          href={link.path}
          target="_blank"
          key={index}
          rel="noopener noreferrer"
          className="hover:font-bold py-3"
        >
          {link.title}
        </a>
      )
    }

    const comparedPaths = comparePaths(currentPath, link.path)
    return (
      <Link
        href={link.path}
        passHref
        key={index}
        className={classnames('appSubtitle !text-xl !mb-0 !font-normal !text-left py-3', {
          'underline underline-offset-2': comparedPaths.samePath && comparedPaths.sameSearch,
        })}
        onClick={e => onClickSideBarLink(e, comparedPaths)}
      >
        {link.title}
      </Link>
    )
  }

  return (
    <>
      <div
        className="flex items-center text-4xl cursor-pointer"
        onClick={() => {
          setOpenSideMenu(!openSideMenu)
        }}
      >
        <HamburgerMenu />
      </div>
      <SideModal
        className="!w-[400px]"
        leftSide={true}
        open={openSideMenu}
        onClose={() => setOpenSideMenu(false)}
      >
        <div className="flex flex-col h-full">
          <div className="flex flex-col text-lg divide-y justify-center">
            {linksAvailable.map((link, index) => {
              return renderLinks(link, index)
            })}
          </div>
        </div>
        <div className="flex flex-row w-full items-center justify-center">
          <GoToOrderButton
            className="w-full text-center !text-base"
            onClick={e => onClickSideBarLink(e, comparedOrderPage)}
          />
        </div>
      </SideModal>
    </>
  )
}

export default function MobileNavbarLinks(props: Readonly<NavbarLinksProps>) {
  const {links} = props
  if (links?.length <= 1) return null

  return (
    <Suspense fallback={null}>
      <MobileNavbarLinksInner {...props} />
    </Suspense>
  )
}
